import { getWrestlerName } from './wrestlerUtils';
import React, { useState, useEffect, useCallback } from 'react';
import { PLES } from './plesDatabase';
import { TITLES_DATABASE, TITLE_CATEGORIES } from './titlesDatabase';
import placeholderTitle from '../assets/Placeholder_Title.png';
import placeholderImg from '../assets/placeholder.png';
import { collection, getDocs, doc, setDoc, deleteDoc, query, where, addDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage, auth, db } from '../firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CloseIcon from '@mui/icons-material/Close';
import background from '../assets/Background_Test.jpg';
import RosterPage from './RosterPage';
import CustomRosterManager from './CustomRosterManager';
import ImportRosterFlow, { loadImportedWrestlers } from './ImportRosterFlow';
import DraftPage from './DraftPage';
import RosterReview from './RosterReview';
import SetChampions from './SetChampions';
import GameSettings from './GameSettings';

// GM Renders
import gmAdamPearce from '../assets/gm/94400_ADAM_PEARCE.png';
import gmNickAldis from '../assets/gm/121300_NICK_ALDIS.png';
import gmShawnMichaels from '../assets/gm/45750_SHAWN_MICHAELS.png';
import gmAva from '../assets/gm/121400_AVA.png';
import gmStephanie from '../assets/gm/14700_STEPHANIE_MCMAHON.png';
import gmPaulHeyman from '../assets/gm/37410_PAUL_HEYMAN_14.png';
import gmWilliamRegal from '../assets/gm/94010_WILLIAM_REGAL.png';
import gmMickFoley from '../assets/gm/14400_MICK_FOLEY.png';
import gmTeddyLong from '../assets/gm/28600_TEDDY_LONG.png';
import gmEricBischoff from '../assets/gm/93900_ERIC_BISCHOFF.png';
import gmSherri from '../assets/gm/42850_SENSATIONAL_SHERRI.png';
import gmMissElizabeth from '../assets/gm/23450_MISS_ELIZABETH.png';
import gmMrFuji from '../assets/gm/130250_MR_FUJI.png';
import gmBobbyHeenan from '../assets/gm/24900_BOBBY_HENNAN.png';
import gmCMPunk from '../assets/gm/31250_CM_PUNK.png';
import gmXavierWoods from '../assets/gm/42030_XAVIER_WOODS.png';
import gmTylerBreeze from '../assets/gm/58110_TYLER_BREEZE.png';
import gmStacyKeibler from '../assets/gm/148600_STACY_KEIBLER_GM.png';
import gmAnonymousGM from '../assets/gm/149100_ANONYMOUS_GM.png';

// Brand Logos
import logoRaw from '../assets/brands/logos/RAW25_LOGO.png';
import logoSmackDown from '../assets/brands/logos/SMACKDOWN25_LOGO.png';
import logoNXT from '../assets/brands/logos/NXT_LOGO.png';
import logoNXT20 from '../assets/brands/logos/NXT20_LOGO.png';
import logoWCW from '../assets/brands/logos/WCW_LOGO.png';
import logoECW from '../assets/brands/logos/ECW_LOGO.png';
import logoNXTMutiny from '../assets/brands/logos/NXTMUTINY_LOGO.png';

// Brand Backgrounds
import bgRaw from '../assets/brands/backgrounds/RAW25_BACKGROUND.png';
import bgSmackDown from '../assets/brands/backgrounds/SMACKDOWN25_BACKGROUND.png';
import bgNXT from '../assets/brands/backgrounds/NXT_BACKGROUND.png';
import bgNXT20 from '../assets/brands/backgrounds/NXT20_BACKGROUND.png';
import bgWCW from '../assets/brands/backgrounds/WCW_BACKGROUND.png';
import bgECW from '../assets/brands/backgrounds/ECW_BACKGROUND.png';
import bgNXTMutiny from '../assets/brands/backgrounds/NXTMUTINY_BACKGROUND.png';


// Dynamic wrestler render loader
const getWrestlerRender = (w) => {
  if (!w) return null;
  if (w.customRender) return w.customRender;
  if (w.wrestler_id) return process.env.PUBLIC_URL + '/wrestlers/' + w.wrestler_id + '-render.png';
  return null;
};


const GM_LIST = [
  { name: 'Adam Pearce', img: gmAdamPearce },
  { name: 'Nick Aldis', img: gmNickAldis },
  { name: 'Shawn Michaels', img: gmShawnMichaels },
  { name: 'Ava', img: gmAva },
  { name: 'Stephanie McMahon', img: gmStephanie },
  { name: 'Paul Heyman', img: gmPaulHeyman },
  { name: 'William Regal', img: gmWilliamRegal },
  { name: 'Mick Foley', img: gmMickFoley },
  { name: 'Teddy Long', img: gmTeddyLong },
  { name: 'Eric Bischoff', img: gmEricBischoff },
  { name: 'Sensational Sherri', img: gmSherri },
  { name: 'Miss Elizabeth', img: gmMissElizabeth },
  { name: 'Mr Fuji', img: gmMrFuji },
  { name: 'Bobby Heenan', img: gmBobbyHeenan },
  { name: 'CM Punk', img: gmCMPunk },
  { name: 'Xavier Woods', img: gmXavierWoods },
  { name: 'Tyler Breeze', img: gmTylerBreeze },
  { name: 'Stacy Keibler', img: gmStacyKeibler },
  { name: 'Anonymous GM', img: gmAnonymousGM },
];


// ── Storage upload helper ──────────────────────────────────────────
async function uploadToStorage(file, userId, type, id) {
  var path = 'renders/' + userId + '/' + type + '/' + id + '_' + Date.now();
  var storageRef = ref(storage, path);
  var snapshot = await uploadBytes(storageRef, file);
  var url = await getDownloadURL(snapshot.ref);
  return { url: url, path: path };
}

const OFFICIAL_BRANDS = [
  { name: 'Raw', color: '#c0392b', logo: logoRaw, bg: bgRaw },
  { name: 'SmackDown', color: '#1a6bb5', logo: logoSmackDown, bg: bgSmackDown },
  { name: 'NXT', color: '#6c3483', logo: logoNXT, bg: bgNXT },
  { name: 'NXT 2.0', color: '#148f77', logo: logoNXT20, bg: bgNXT20 },
  { name: 'WCW', color: '#b7950b', logo: logoWCW, bg: bgWCW },
  { name: 'ECW', color: '#ba4a00', logo: logoECW, bg: bgECW },
  { name: 'NXT Mutiny', color: '#212f3c', logo: logoNXTMutiny, bg: bgNXTMutiny },
];

const css = `
  * { box-sizing: border-box; }
  html { font-size: 133%; }
  .brand-card { transition: filter 0.3s, outline 0.2s, transform 0.2s !important; }
  .brand-card .brand-bg { transition: filter 0.3s !important; filter: blur(4px) brightness(0.55); }
  .brand-card:hover .brand-bg { filter: blur(0px) brightness(0.8) !important; }
  .brand-card.selected .brand-bg { filter: blur(0px) brightness(1) !important; }
  .brand-card:hover { transform: scale(1.02); }
  .brand-card.selected { transform: scale(1.03); }
  .hover-outline:hover { outline: 1.5px solid rgba(255,255,255,0.65) !important; }
  .btn-wwe:hover { background: rgba(255,255,255,0.1) !important; border-color: rgba(255,255,255,0.7) !important; color: #fff !important; }
  .chip-select:hover { outline: 1.5px solid rgba(255,255,255,0.5) !important; background: rgba(255,255,255,0.08) !important; }
  .gm-card { transition: filter 0.25s, outline 0.2s; }
  .gm-card .gm-bg { transition: filter 0.3s; filter: blur(4px) brightness(0.5); }
  .gm-card:hover .gm-bg { filter: blur(0px) brightness(0.8) !important; }
  .gm-card.selected .gm-bg { filter: blur(0px) brightness(1) !important; }
  .gm-card .gm-render { transition: filter 0.25s; filter: brightness(0.65); }
  .gm-card:hover .gm-render { filter: brightness(0.9) !important; }
  .gm-card.selected .gm-render { filter: brightness(1) !important; }
  .slot-card { transition: outline 0.2s, transform 0.2s; }
  .slot-card .slot-bg { transition: filter 0.35s; filter: blur(5px) brightness(0.5); }
  .slot-card:hover .slot-bg { filter: blur(0px) brightness(0.8) !important; }
  .slot-card.selected .slot-bg { filter: blur(0px) brightness(1) !important; }
  .slot-card:hover { transform: scale(1.02); }
  .delete-btn { opacity: 0; transition: opacity 0.2s; }
  .custom-card:hover .delete-btn { opacity: 1 !important; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 2px; }
`;

const pageStyle = {
  minHeight: '100vh',
  backgroundImage: `url(${background})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  fontFamily: "'Monda', sans-serif",
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingBottom: '60px',
};

const overlayStyle = {
  position: 'absolute', inset: 0,
  background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.78) 100%)',
  pointerEvents: 'none',
};

const panel = {
  background: 'rgba(8,8,8,0.8)',
  border: '1px solid rgba(255,255,255,0.09)',
  borderRadius: '10px',
  boxShadow: '0 16px 60px rgba(0,0,0,0.75), inset 0 1px 0 rgba(255,255,255,0.04)',
};

const titleSt = {
  fontFamily: "'Anton', sans-serif",
  letterSpacing: '3px',
  color: '#fff',
  textShadow: '0 0 28px rgba(180,0,0,0.5)',
};

const btnSt = {
  fontFamily: "'Monda', sans-serif",
  letterSpacing: '1.5px',
  fontSize: '0.6rem',
  background: 'transparent',
  border: '1px solid rgba(255,255,255,0.35)',
  color: 'rgba(255,255,255,0.8)',
  padding: '8px 22px',
  borderRadius: '4px',
  cursor: 'pointer',
  transition: 'background 0.18s, border-color 0.18s, color 0.18s',
};

const inputSt = {
  background: 'rgba(255,255,255,0.06)',
  border: '1px solid rgba(255,255,255,0.15)',
  borderRadius: '4px',
  padding: '9px 12px',
  color: '#fff',
  fontSize: '0.7rem',
  fontFamily: "'Monda', sans-serif",
  width: '100%',
  outline: 'none',
  transition: 'border-color 0.2s',
};

const labelSt = {
  color: 'rgba(255,255,255,0.4)',
  fontSize: '0.58rem',
  letterSpacing: '1px',
  fontFamily: "'Monda', sans-serif",
  marginBottom: '5px',
  display: 'block',
};

const logoMain = process.env.PUBLIC_URL + '/logo-main.png';

const LogoPlaceholder = ({ size = 120 }) => (
  <img src={logoMain} alt="Logo"
    style={{ width: size, height: size, objectFit: 'contain', filter: 'drop-shadow(0 0 12px rgba(255,255,255,0.15))' }}
    onError={e => { e.target.style.display='none'; }}
  />
);

// ── Popup Custom Brand ──────────────────────────────────────────────
const getTitleRenderBrand = (titleId) => {
  if (!titleId) return null;
  return process.env.PUBLIC_URL + '/titles/' + titleId + '-render.png';
};

const TitlePickerPopup = ({ slot, onClose, onConfirm, user, customTitles: customTitlesProp, onAddCustomTitle }) => {
  const [titleSearch, setTitleSearch] = useState('');
  const [titleCategory, setTitleCategory] = useState('ALL');
  const [selectedTitle, setSelectedTitle] = useState(slot.titleOverride || null);
  const [showAddCustom, setShowAddCustom] = useState(false);
  const [customForm, setCustomForm] = useState({ name: '', render: null, gender: slot.gender || 'male', isTagTeam: slot.isTagTeam || false });
  const customTitles = customTitlesProp || [];

  const allTitles = [...TITLES_DATABASE, ...customTitles];
  const filteredTitles = allTitles.filter(t => {
    const matchCat = titleCategory === 'ALL' || t.category === titleCategory || (titleCategory === 'CUSTOM' && t.isCustom);
    const matchSearch = t.name.toLowerCase().includes(titleSearch.toLowerCase());
    return matchCat && matchSearch;
  });

  const [uploadingTitle, setUploadingTitle] = React.useState(false);
  const handleTitleUpload = async (e) => {
    var file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { alert('File too large — max 5MB'); e.target.value = ''; return; }
    setUploadingTitle(true);
    try {
      var result = await uploadToStorage(file, (user && user.uid) || (auth.currentUser && auth.currentUser.uid) || 'anon', 'title', 'custom_' + Date.now());
      setCustomForm(function(p) { return { ...p, render: result.url, renderPath: result.path }; });
    } catch (err) {
      console.error('Title upload failed:', err);
      var reader = new FileReader();
      reader.onload = function(ev) { setCustomForm(function(p) { return { ...p, render: ev.target.result }; }); };
      reader.readAsDataURL(file);
    } finally {
      setUploadingTitle(false);
    }
  };

  const handleSaveCustom = () => {
    if (!customForm.name) return;
    const t = { id: 'custom-' + Date.now(), name: customForm.name, render: customForm.render, gender: customForm.gender, isTagTeam: customForm.isTagTeam, category: 'CUSTOM', isCustom: true };
    if (onAddCustomTitle) onAddCustomTitle(t);
    setSelectedTitle(t);
    setShowAddCustom(false);
    setCustomForm({ name: '', render: null, gender: slot.gender || 'male', isTagTeam: slot.isTagTeam || false });
  };

  const S2 = {
    panel: { background: 'rgba(8,6,0,0.95)', border: '1px solid rgba(212,175,55,0.2)', borderRadius: '10px' },
    mono: { fontFamily: "'Monda', sans-serif" },
    anton: { fontFamily: "'Anton', sans-serif" },
    input: { background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.2)', borderRadius: '4px', padding: '7px 12px', color: '#fff', fontSize: '0.6rem', fontFamily: "'Monda',sans-serif", outline: 'none', width: '100%' },
    btn: { fontFamily: "'Monda', sans-serif", letterSpacing: '1.5px', fontSize: '0.55rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.25)', color: 'rgba(255,255,255,0.6)', padding: '6px 14px', borderRadius: '4px', cursor: 'pointer' },
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 400, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.88)', backdropFilter: 'blur(4px)' }}>
      <div style={{ ...S2.panel, width: '100%', maxWidth: '520px', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <div style={{ padding: '18px 20px 12px', borderBottom: '1px solid rgba(212,175,55,0.15)', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img loading="lazy" src={(selectedTitle && (selectedTitle.render || getTitleRenderBrand(selectedTitle.id))) || placeholderTitle} alt=""
            style={{ height: '40px', objectFit: 'contain', filter: 'drop-shadow(0 0 8px rgba(212,175,55,0.5))' }}
            onError={e => { e.target.src = placeholderTitle; }} />
          <div>
            <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.9rem', letterSpacing: '2px', color: '#d4af37' }}>{slot.label}</div>
            <div style={{ ...S2.mono, fontSize: '0.42rem', color: 'rgba(212,175,55,0.4)', marginTop: '2px' }}>
              {slot.isTagTeam ? 'TAG TEAM · ' : ''}{slot.gender && slot.gender.toUpperCase()}
            </div>
          </div>
        </div>

        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: '12px 20px' }}>
          {/* Category filters */}
          <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', flexWrap: 'wrap' }}>
            {['ALL', ...TITLE_CATEGORIES, 'CUSTOM'].map(cat => (
              <button key={cat} onClick={() => setTitleCategory(cat)}
                style={{ ...S2.mono, fontSize: '0.4rem', letterSpacing: '1px', background: 'transparent', border: '1px solid ' + (titleCategory === cat ? 'rgba(212,175,55,0.6)' : 'rgba(212,175,55,0.15)'), color: titleCategory === cat ? '#d4af37' : 'rgba(212,175,55,0.4)', padding: '3px 8px', borderRadius: '3px', cursor: 'pointer' }}>
                {cat}
              </button>
            ))}
          </div>

          {/* Search + add custom */}
          <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
            <input style={{ ...S2.input, flex: 1 }} placeholder="Search..." value={titleSearch} onChange={e => setTitleSearch(e.target.value)} />
            <button onClick={() => setShowAddCustom(p => !p)}
              style={{ ...S2.btn, borderColor: 'rgba(212,175,55,0.4)', color: 'rgba(212,175,55,0.7)', whiteSpace: 'nowrap', fontSize: '0.48rem' }}>
              + CUSTOM
            </button>
          </div>

          {/* Custom form */}
          {showAddCustom && (
            <div style={{ ...S2.panel, padding: '10px 12px', marginBottom: '8px' }}>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                <div onClick={() => document.getElementById('brandTitleUpload').click()}
                  style={{ width: '90px', height: '52px', border: '1px dashed rgba(212,175,55,0.3)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', overflow: 'hidden', background: 'rgba(212,175,55,0.04)', flexShrink: 0 }}>
                  {customForm.render ? <img loading="lazy" src={customForm.render} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    : <span style={{ ...S2.mono, fontSize: '0.34rem', color: 'rgba(212,175,55,0.3)', textAlign: 'center', lineHeight: 1.6 }}>Upload PNG<br/>max 5MB<br/>1024×512 (2:1)</span>}
                </div>
                <input id="brandTitleUpload" type="file" accept="image/png" style={{ display: 'none' }} onChange={handleTitleUpload} />
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  <input style={S2.input} placeholder="Title name *" value={customForm.name} onChange={e => setCustomForm(p => ({ ...p, name: e.target.value }))} />
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <select style={{ ...S2.input, flex: 1 }} value={customForm.gender} onChange={e => setCustomForm(p => ({ ...p, gender: e.target.value }))}>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="all">Mixed</option>
                    </select>
                    <select style={{ ...S2.input, flex: 1 }} value={customForm.isTagTeam ? 'tag' : 'single'} onChange={e => setCustomForm(p => ({ ...p, isTagTeam: e.target.value === 'tag' }))}>
                      <option value="single">Singles</option>
                      <option value="tag">Tag Team</option>
                    </select>
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '6px', marginTop: '8px' }}>
                <button style={{ ...S2.btn, fontSize: '0.44rem', padding: '3px 8px' }} onClick={() => setShowAddCustom(false)}>CANCEL</button>
                <button style={{ ...S2.btn, fontSize: '0.44rem', padding: '3px 8px', borderColor: 'rgba(212,175,55,0.5)', color: '#d4af37' }} onClick={handleSaveCustom}>ADD</button>
              </div>
            </div>
          )}

          {/* Title list */}
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {selectedTitle && (
              <div style={{ ...S2.panel, padding: '7px 10px', marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img loading="lazy" src={selectedTitle.render || getTitleRenderBrand(selectedTitle.id) || placeholderTitle} alt="" style={{ height: '28px', objectFit: 'contain' }} onError={e => { e.target.src = placeholderTitle; }} />
                <div style={{ flex: 1, ...S2.mono, fontSize: '0.48rem', color: '#d4af37' }}>{selectedTitle.name}</div>
                <span style={{ color: '#d4af37' }}>✓</span>
              </div>
            )}
            {filteredTitles.map(t => {
              const isSel = selectedTitle && selectedTitle.id === t.id;
              return (
                <div key={t.id} onClick={() => setSelectedTitle(isSel ? null : t)}
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px', borderRadius: '4px', borderBottom: '1px solid rgba(255,255,255,0.04)', background: isSel ? 'rgba(212,175,55,0.1)' : 'transparent', cursor: 'pointer' }}>
                  <img loading="lazy" src={t.render || getTitleRenderBrand(t.id) || placeholderTitle} alt="" style={{ height: '26px', objectFit: 'contain', filter: 'drop-shadow(0 1px 4px rgba(212,175,55,0.3))' }} onError={e => { e.target.src = placeholderTitle; }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ ...S2.mono, fontSize: '0.48rem', color: isSel ? '#d4af37' : '#fff' }}>{t.name}</div>
                    <div style={{ ...S2.mono, fontSize: '0.34rem', color: 'rgba(255,255,255,0.25)' }}>{t.category} · {t.isTagTeam ? 'TAG' : 'SINGLES'} · {t.gender}</div>
                  </div>
                  {isSel && <span style={{ color: '#d4af37' }}>✓</span>}
                </div>
              );
            })}
          </div>

          {/* Footer */}
          <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px', borderTop: '1px solid rgba(212,175,55,0.15)', marginTop: '8px' }}>
            <button style={S2.btn} onClick={onClose}>CANCEL</button>
            <button style={{ ...S2.btn, borderColor: 'rgba(212,175,55,0.5)', color: '#d4af37' }} onClick={() => { onConfirm(selectedTitle); onClose(); }}>CONFIRM</button>
          </div>
        </div>
      </div>
    </div>
  );
};

const BRAND_COLOR_PRESETS = [
  '#c0392b', '#e74c3c', '#922b21',  // Reds
  '#1a6bb5', '#2980b9', '#1a5276',  // Blues
  '#6c3483', '#8e44ad', '#4a235a',  // Purples
  '#148f77', '#1abc9c', '#0e6655',  // Teals
  '#b7950b', '#d4af37', '#f39c12',  // Golds
  '#ba4a00', '#e67e22', '#784212',  // Oranges
  '#1e8449', '#27ae60', '#145a32',  // Greens
  '#212f3c', '#566573', '#17202a',  // Darks
];

const BrandColorPicker = ({ value, onChange }) => {
  const nativeRef = React.useRef(null);
  var isCustom = !BRAND_COLOR_PRESETS.some(function(c) { return c.toLowerCase() === value.toLowerCase(); });

  return (
    <div>
      {/* Swatch grid — 18 presets + 1 custom "+" cell */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(10, 1fr)', gap: '5px', marginBottom: '8px' }}>
        {BRAND_COLOR_PRESETS.map(function(c) {
          var isSelected = value.toLowerCase() === c.toLowerCase();
          return (
            <div key={c} onClick={function() { onChange(c); }}
              style={{
                width: '100%', paddingBottom: '100%', borderRadius: '3px',
                background: c, cursor: 'pointer', position: 'relative',
                outline: isSelected ? '2px solid #fff' : '2px solid transparent',
                outlineOffset: '1px',
                transition: 'outline 0.1s, transform 0.1s',
                transform: isSelected ? 'scale(1.15)' : 'scale(1)',
              }}
            />
          );
        })}

        {/* Custom color cell — shows current custom color if active, else "+" */}
        <div onClick={function() { nativeRef.current && nativeRef.current.click(); }}
          style={{
            width: '100%', paddingBottom: '100%', borderRadius: '3px',
            background: isCustom ? value : 'rgba(255,255,255,0.06)',
            cursor: 'pointer', position: 'relative',
            outline: isCustom ? '2px solid #fff' : '2px solid transparent',
            outlineOffset: '1px',
            border: isCustom ? 'none' : '1px dashed rgba(255,255,255,0.25)',
            transition: 'outline 0.1s, transform 0.1s',
            transform: isCustom ? 'scale(1.15)' : 'scale(1)',
          }}>
          {!isCustom && (
            <span style={{
              position: 'absolute', inset: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'rgba(255,255,255,0.45)', fontSize: '0.75rem', lineHeight: 1,
              fontFamily: 'system-ui',
            }}>+</span>
          )}
        </div>

        {/* Hidden native color input */}
        <input ref={nativeRef} type="color" value={value}
          onChange={function(e) { onChange(e.target.value); }}
          style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }} />
      </div>

      {/* Current color preview + hex label */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ width: '22px', height: '22px', borderRadius: '3px', background: value, flexShrink: 0, border: '1px solid rgba(255,255,255,0.15)' }} />
        <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.5rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.3)' }}>
          {value.toUpperCase()}{isCustom ? ' · CUSTOM' : ''}
        </span>
      </div>
    </div>
  );
};

const CustomBrandPopup = ({ onClose, onConfirm, user }) => {
  const [form, setForm] = useState({ name: '', color: '#c0392b', bgPreview: null, logoPreview: null, customTitles: [] });

  const [uploading, setUploading] = React.useState({});
  const handleFile = useCallback(async (e, key) => {
    var file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { alert('File too large — max 5MB'); e.target.value = ''; return; }
    setUploading(function(u) { return { ...u, [key]: true }; });
    try {
      var result = await uploadToStorage(file, 'shared', 'brand', key + '_' + Date.now());
      setForm(function(p) { return { ...p, [key]: result.url }; });
    } catch (err) {
      console.error('Brand upload failed:', err);
      var reader = new FileReader();
      reader.onload = function(ev) { setForm(function(p) { return { ...p, [key]: ev.target.result }; }); };
      reader.readAsDataURL(file);
    } finally {
      setUploading(function(u) { return { ...u, [key]: false }; });
    }
  }, []);

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)' }}>
      <div style={{ ...panel, width: '100%', maxWidth: '600px', padding: '32px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
          <LogoPlaceholder size={100} />
          <div style={{ ...titleSt, fontSize: '1rem' }}>CUSTOM BRAND</div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div>
              <label style={labelSt}>BRAND NAME</label>
              <input style={inputSt} value={form.name}
                onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
                onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
                onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'} />
            </div>
            <div>
              <label style={labelSt}>BRAND COLOR</label>
              <BrandColorPicker value={form.color} onChange={function(c) { setForm(function(p) { return { ...p, color: c }; }); }} />
            </div>
            <div>
              <label style={labelSt}>BACKGROUND (.jpg/.png)</label>
              <div style={{ position: 'relative' }}>
                <div onClick={() => document.getElementById('bgUp').click()}
                  style={{ border: '1px dashed rgba(255,255,255,0.15)', borderRadius: '6px', height: '65px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', overflow: 'hidden' }}>
                  {form.bgPreview
                    ? <img loading="lazy" src={form.bgPreview} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    : <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.52rem', fontFamily: "'Monda', sans-serif", textAlign: 'center', lineHeight: 1.6 }}>Import background<br/>.jpg/.png · max 5MB<br/>1920×1080 (16:9)</span>}
                </div>
                {form.bgPreview && (
                  <button onClick={e => { e.stopPropagation(); setForm(p => ({ ...p, bgPreview: null })); document.getElementById('bgUp').value = ''; }}
                    style={{ position: 'absolute', top: '4px', right: '4px', background: 'rgba(0,0,0,0.7)', border: '1px solid rgba(231,76,60,0.5)', borderRadius: '3px', color: 'rgba(231,76,60,0.8)', cursor: 'pointer', fontSize: '0.5rem', padding: '2px 5px', lineHeight: 1 }}>✕</button>
                )}
              </div>
              <input id="bgUp" type="file" accept="image/*" style={{ display: 'none' }} onChange={e => handleFile(e, 'bgPreview')} />
            </div>
            <div>
              <label style={labelSt}>LOGO (.png)</label>
              <div style={{ position: 'relative' }}>
                <div onClick={() => document.getElementById('logoUp').click()}
                  style={{ border: '1px dashed rgba(255,255,255,0.15)', borderRadius: '6px', height: '55px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', overflow: 'hidden' }}>
                  {form.logoPreview
                    ? <img loading="lazy" src={form.logoPreview} alt="" style={{ height: '44px', objectFit: 'contain' }} />
                    : <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.52rem', fontFamily: "'Monda', sans-serif", textAlign: 'center', lineHeight: 1.6 }}>Import logo<br/>.png · max 5MB<br/>1024×512 (2:1)</span>}
                </div>
                {form.logoPreview && (
                  <button onClick={e => { e.stopPropagation(); setForm(p => ({ ...p, logoPreview: null })); document.getElementById('logoUp').value = ''; }}
                    style={{ position: 'absolute', top: '4px', right: '4px', background: 'rgba(0,0,0,0.7)', border: '1px solid rgba(231,76,60,0.5)', borderRadius: '3px', color: 'rgba(231,76,60,0.8)', cursor: 'pointer', fontSize: '0.5rem', padding: '2px 5px', lineHeight: 1 }}>✕</button>
                )}
              </div>
              <input id="logoUp" type="file" accept="image/png" style={{ display: 'none' }} onChange={e => handleFile(e, 'logoPreview')} />
            </div>
          </div>
          <div style={{ overflowY: 'auto', maxHeight: '340px' }}>
            <label style={labelSt}>SET CHAMPIONSHIPS</label>
            {[
              { key: 'male-world',     label: 'MALE — MAJOR',      gender: 'male',   isTagTeam: false },
              { key: 'male-minor',     label: 'MALE — MINOR',      gender: 'male',   isTagTeam: false },
              { key: 'female-world',   label: 'FEMALE — MAJOR',    gender: 'female', isTagTeam: false },
              { key: 'female-minor',   label: 'FEMALE — MINOR',    gender: 'female', isTagTeam: false },
              { key: 'tagteam-male',   label: 'TAG TEAM — MALE',   gender: 'male',   isTagTeam: true  },
              { key: 'tagteam-female', label: 'TAG TEAM — FEMALE', gender: 'female', isTagTeam: true  },
            ].map(slot => {
              const titleOverride = form.championships && form.championships[slot.key];
              return (
                <div key={slot.key} style={{ marginBottom: '8px' }}>
                  <label style={{ ...labelSt, fontSize: '0.52rem', marginBottom: '3px' }}>{slot.label}</label>
                  <div
                    onClick={() => setForm(p => ({ ...p, _titlePickerSlot: slot }))}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px', border: '1px dashed rgba(255,255,255,0.15)', borderRadius: '4px', padding: '6px 10px', cursor: 'pointer', background: 'rgba(255,255,255,0.02)' }}>
                    {titleOverride ? (
                      <>
                        <img loading="lazy" src={titleOverride.render || getTitleRenderBrand(titleOverride.id) || placeholderTitle} alt="" style={{ height: '24px', objectFit: 'contain', filter: 'drop-shadow(0 0 6px rgba(212,175,55,0.6))' }} onError={e => { e.target.src = placeholderTitle; }} />
                        <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.52rem', color: '#d4af37', flex: 1 }}>{titleOverride.name}</span>
                        <button onClick={e => { e.stopPropagation(); setForm(p => { const c = { ...(p.championships || {}) }; delete c[slot.key]; return { ...p, championships: c }; }); }}
                          style={{ background: 'none', border: 'none', color: 'rgba(231,76,60,0.6)', cursor: 'pointer', fontSize: '0.6rem' }}>✕</button>
                      </>
                    ) : (
                      <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.5rem', color: 'rgba(255,255,255,0.25)' }}>Set title... &nbsp;＋</span>
                    )}
                  </div>
                </div>
              );
            })}
            {form._titlePickerSlot && (
              <TitlePickerPopup
                slot={form._titlePickerSlot}
                user={user}
                customTitles={form.customTitles || []}
                onAddCustomTitle={(t) => setForm(p => ({ ...p, customTitles: [...(p.customTitles || []), t] }))}
                onClose={() => setForm(p => ({ ...p, _titlePickerSlot: null }))}
                onConfirm={title => setForm(p => ({ ...p, championships: { ...(p.championships || {}), [p._titlePickerSlot.key]: title }, _titlePickerSlot: null }))}
              />
            )}
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '22px' }}>
          <button className="btn-wwe" style={btnSt} onClick={onClose}>CANCEL</button>
          <button className="btn-wwe" style={{ ...btnSt, borderColor: form.name && form.logoPreview && form.bgPreview ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.18)', color: form.name && form.logoPreview && form.bgPreview ? '#fff' : 'rgba(255,255,255,0.25)' }} onClick={() => form.name && form.logoPreview && form.bgPreview && onConfirm(form)} disabled={!form.name || !form.logoPreview || !form.bgPreview}>CONFIRM {(!form.name || !form.logoPreview || !form.bgPreview) ? '⚠' : ''}</button>
        </div>
      </div>
    </div>
  );
};

// ── Popup Custom GM ─────────────────────────────────────────────────
const CustomGMPopup = ({ onClose, onConfirm }) => {
  const [name, setName] = useState('');
  const [imgPreview, setImgPreview] = useState(null);

  const [uploadingGM, setUploadingGM] = React.useState(false);
  const handleFile = async (e) => {
    var file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { alert('File too large — max 5MB'); e.target.value = ''; return; }
    setUploadingGM(true);
    try {
      var result = await uploadToStorage(file, 'shared', 'gm', 'custom_' + Date.now());
      setImgPreview(result.url);
    } catch (err) {
      console.error('GM upload failed:', err);
      var reader = new FileReader();
      reader.onload = function(ev) { setImgPreview(ev.target.result); };
      reader.readAsDataURL(file);
    } finally {
      setUploadingGM(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)' }}>
      <div style={{ ...panel, width: '100%', maxWidth: '440px', padding: '32px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
          <LogoPlaceholder size={100} />
          <div style={{ ...titleSt, fontSize: '1rem' }}>CUSTOM GM</div>
        </div>
        <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
          <div style={{ flex: 1 }}>
            <label style={labelSt}>GM NAME</label>
            <input style={inputSt} value={name}
              onChange={e => setName(e.target.value)}
              onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
              onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'} />
          </div>
          <div onClick={() => document.getElementById('gmImg').click()}
            style={{ width: '110px', height: '130px', border: '1px dashed rgba(255,255,255,0.15)', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', overflow: 'hidden', flexShrink: 0 }}>
            {imgPreview
              ? <img loading="lazy" src={imgPreview} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} />
              : <span style={{ color: 'rgba(255,255,255,0.22)', fontSize: '0.52rem', fontFamily: "'Monda', sans-serif", textAlign: 'center', padding: '8px', lineHeight: 1.6 }}>Import GM Render<br/>.png · max 5MB<br/>1024×1024 (1:1)</span>}
          </div>
          <input id="gmImg" type="file" accept="image/png" style={{ display: 'none' }} onChange={handleFile} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '24px' }}>
          <button className="btn-wwe" style={btnSt} onClick={onClose}>CANCEL</button>
          <button className="btn-wwe" style={{ ...btnSt, borderColor: 'rgba(255,255,255,0.55)' }}
            onClick={() => name && onConfirm({ name, imgPreview })}>CONFIRM</button>
        </div>
      </div>
    </div>
  );
};

// ── Popup Roster ────────────────────────────────────────────────────
const RosterPopup = ({ wrestlers, selected, setSelected, onClose, onConfirm }) => {
  const [search, setSearch] = useState('');
  const filtered = wrestlers.filter(w => w.name?.toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)' }}>
      <div style={{ ...panel, width: '100%', maxWidth: '720px', padding: '28px', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{ ...titleSt, fontSize: '0.9rem' }}>CUSTOM ROSTER — {selected.length} selected</div>
          <input style={{ ...inputSt, width: '200px', fontSize: '0.65rem', padding: '7px 10px' }} placeholder="Search..."
            value={search} onChange={e => setSearch(e.target.value)}
            onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
            onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'} />
        </div>
        <div style={{ overflowY: 'auto', flex: 1, display: 'flex', flexWrap: 'wrap', gap: '6px', alignContent: 'flex-start', padding: '4px 0' }}>
          {filtered.map(w => {
            const sel = selected.find(p => p.wrestler_id === w.wrestler_id);
            return (
              <div key={w.wrestler_id} className="chip-select"
                onClick={() => setSelected(prev => sel ? prev.filter(p => p.wrestler_id !== w.wrestler_id) : [...prev, w])}
                style={{ padding: '5px 14px', border: `1px solid ${sel ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.12)'}`, borderRadius: '20px', background: sel ? 'rgba(255,255,255,0.1)' : 'transparent', color: sel ? '#fff' : 'rgba(255,255,255,0.45)', fontSize: '0.65rem', cursor: 'pointer', fontFamily: "'Monda', sans-serif", transition: 'background 0.15s, border-color 0.15s, color 0.15s', outline: '1.5px solid transparent' }}>
                {getWrestlerName(w, 'display')}
              </div>
            );
          })}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', paddingTop: '14px', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
          <button className="btn-wwe" style={btnSt} onClick={() => setSelected(wrestlers)}>SELECT ALL</button>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button className="btn-wwe" style={btnSt} onClick={onClose}>CANCEL</button>
            <button className="btn-wwe" style={{ ...btnSt, borderColor: 'rgba(255,255,255,0.55)' }} onClick={() => onConfirm(selected)}>CONFIRM</button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ── Popup Delete Confirm ────────────────────────────────────────────
const DeleteConfirmPopup = ({ title, subtitle, onClose, onConfirm }) => (
  <div style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)' }}>
    <div style={{ ...panel, width: '100%', maxWidth: '380px', padding: '32px', textAlign: 'center' }}>
      <div style={{ ...titleSt, fontSize: '0.95rem', marginBottom: '12px', color: '#e74c3c', textShadow: '0 0 20px rgba(200,0,0,0.5)' }}>{title}</div>
      <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.75rem', fontFamily: "'Monda', sans-serif", marginBottom: '24px' }}>
        {subtitle}<br />This action cannot be undone.
      </div>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
        <button className="btn-wwe" style={btnSt} onClick={onClose}>CANCEL</button>
        <button className="btn-wwe" style={{ ...btnSt, borderColor: 'rgba(231,76,60,0.6)', color: '#e74c3c' }} onClick={onConfirm}>DELETE</button>
      </div>
    </div>
  </div>
);

// ── MAIN COMPONENT ──────────────────────────────────────────────────

const BRAND_COLORS = { 'Raw': '#c0392b', 'SmackDown': '#1a6bb5', 'NXT': '#a8a9ad', 'NXT 2.0': '#e91e8c', 'ECW': '#7b1fa2', 'WCW': '#e65100', 'NXT Mutiny': '#424242' };

const RivalPickerPopup = ({ rival, onClose, onSave, customBrands = [], customGMs = [], excludeBrand = null, excludeGM = null }) => {
  const allRivalBrands = ['Raw', 'SmackDown', 'NXT', 'NXT 2.0', 'WCW', 'ECW', 'NXT Mutiny', ...customBrands.map(b => b.name)].filter(b => b !== excludeBrand);
  const allRivalGMs = ['Adam Pearce', 'Nick Aldis', 'Shawn Michaels', 'Ava', 'Stephanie McMahon', 'Paul Heyman', 'William Regal', 'Mick Foley', 'Teddy Long', 'Eric Bischoff', 'Sensational Sherri', 'Miss Elizabeth', 'Mr Fuji', 'Bobby Heenan', 'CM Punk', 'Xavier Woods', 'Tyler Breeze', 'Stacy Keibler', 'Anonymous GM', ...customGMs.map(g => g.name)].filter(g => g !== excludeGM);
  const [brand, setBrand] = React.useState(rival?.brand || '');
  const [gm, setGm] = React.useState(rival?.gm || '');
  const panelSt = { background: 'rgba(8,8,8,0.95)', border: '1px solid rgba(255,255,255,0.09)', borderRadius: '10px', boxShadow: '0 20px 80px rgba(0,0,0,0.9)' };
  const inSt = { background: 'rgba(20,20,20,0.95)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '4px', padding: '7px 12px', color: '#fff', fontSize: '0.6rem', fontFamily: "'Monda',sans-serif", outline: 'none', cursor: 'pointer', width: '100%', appearance: 'auto', colorScheme: 'dark' };
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(4px)' }}>
      <div style={{ ...panelSt, width: '100%', maxWidth: '380px', padding: '28px' }}>
        <div style={{ fontFamily: "'Anton',sans-serif", letterSpacing: '3px', color: '#fff', fontSize: '1rem', marginBottom: '20px' }}>SET RIVAL</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div>
            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.46rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '6px' }}>BRAND</div>
            <select style={inSt} value={brand} onChange={e => setBrand(e.target.value)}>
              <option value="">-- Choisir --</option>
              {['Raw', 'SmackDown', 'NXT', 'NXT 2.0', 'WCW', 'ECW', 'NXT Mutiny'].filter(b => b !== excludeBrand).map(b => <option key={b} value={b}>{b}</option>)}
              {customBrands.filter(b => b.name !== excludeBrand).map(b => <option key={b.name} value={b.name}>★ {b.name} [CUSTOM]</option>)}
            </select>
          </div>
          <div>
            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.46rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '6px' }}>GENERAL MANAGER</div>
            <select style={inSt} value={gm} onChange={e => setGm(e.target.value)}>
              <option value="">-- Choisir --</option>
              {['Adam Pearce', 'Nick Aldis', 'Shawn Michaels', 'Ava', 'Stephanie McMahon', 'Paul Heyman', 'William Regal', 'Mick Foley', 'Teddy Long', 'Eric Bischoff', 'Sensational Sherri', 'Miss Elizabeth', 'Mr Fuji', 'Bobby Heenan', 'CM Punk', 'Xavier Woods', 'Tyler Breeze', 'Stacy Keibler', 'Anonymous GM'].filter(g => g !== excludeGM).map(g => <option key={g} value={g}>{g}</option>)}
              {customGMs.map(g => <option key={g.name} value={g.name}>★ {g.name} [CUSTOM]</option>)}
            </select>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button onClick={onClose} style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.55rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.25)', color: 'rgba(255,255,255,0.5)', padding: '7px 18px', borderRadius: '4px', cursor: 'pointer' }}>CANCEL</button>
          <button onClick={() => brand && gm && onSave({ brand, gm })} style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.55rem', background: 'transparent', border: `1px solid ${brand && gm ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.15)'}`, color: brand && gm ? '#fff' : 'rgba(255,255,255,0.25)', padding: '7px 18px', borderRadius: '4px', cursor: 'pointer' }}>CONFIRM</button>
        </div>
      </div>
    </div>
  );
};

export default function GameSlots({ onEnterGame, goToSlots }) {
  const [user] = useAuthState(auth);
  const [slots, setSlots] = useState({ 1: null, 2: null, 3: null, 4: null });
  const [fetchError, setFetchError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [slotNames, setSlotNames] = useState({ 1: '', 2: '', 3: '', 4: '' });
  const [editingSlotName, setEditingSlotName] = useState(null);
  const [step, setStep] = useState('slots');
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedGM, setSelectedGM] = useState(null);
  const [rosterMode, setRosterMode] = useState(null);
  const [gameVersion, setGameVersion] = useState(null);
  const [officialWrestlers, setOfficialWrestlers] = useState([]);
  const [baseRoster, setBaseRoster] = useState([]);
  const [customWrestlers, setCustomWrestlers] = useState([]);
  const [selectedWrestlers, setSelectedWrestlers] = useState([]);
  const [customBrands, setCustomBrands] = useState([]);
  const [customGMs, setCustomGMs] = useState([]);
  const [showCustomBrand, setShowCustomBrand] = useState(false);
  const [showCustomGM, setShowCustomGM] = useState(false);
  const [showRosterPopup, setShowRosterPopup] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteCustomBrand, setDeleteCustomBrand] = useState(null);
  const [deleteCustomGM, setDeleteCustomGM] = useState(null);
  const [showDefaultRoster, setShowDefaultRoster] = useState(false);
  const [showCustomRosterManager, setShowCustomRosterManager] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [existingImports, setExistingImports] = useState([]);
  const [withImports, setWithImports] = useState(true);
  const [showDraft, setShowDraft] = useState(false);
  const [showReview, setShowReview] = useState(false);
  const [reviewRoster, setReviewRoster] = useState([]);
  const [showFinalReview, setShowFinalReview] = useState(false);
  const [finalRoster, setFinalRoster] = useState([]);
  const [showSetChampions, setShowSetChampions] = useState(false);
  const [showGameSettings, setShowGameSettings] = useState(false);
  const [settingsConfirmed, setSettingsConfirmed] = useState(false);
  const [gameSettingsData, setGameSettingsData] = useState({ budget: 3000000, matchType: 'classic', hofTrophies: 10, victoryCriteria: 'fans', difficulty: 'normal', rivals: [null, null, null] });
  const [rivalPickerIdx, setRivalPickerIdx] = useState(null);
  const [draftRoster, setDraftRoster] = useState([]);

  useEffect(() => {
    if (user) {
      fetchSlots(); fetchOfficialWrestlers(null); fetchCustomBrands(); fetchCustomGMs(); fetchCustomWrestlers();
      loadImportedWrestlers(user.uid).then(setExistingImports);
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    var onWrestlersUpdated = function() { fetchCustomWrestlers(); };
    window.addEventListener('wrestlersUpdated', onWrestlersUpdated);
    return function() { window.removeEventListener('wrestlersUpdated', onWrestlersUpdated); };
  }, [user]);

  useEffect(() => {
    if (goToSlots) {
      setStep('slots');
      setSelectedSlot(null);
      setSelectedBrand(null);
      setSelectedGM(null);
      setRosterMode(null);
      setGameVersion(null);
      setShowDraft(false);
      setShowReview(false);
      setShowFinalReview(false);
      setShowSetChampions(false);
      setShowCustomRosterManager(false);
      setDraftRoster([]);
      setFinalRoster([]);
    }
  }, [goToSlots]);

  const fetchSlots = async () => {
    setIsLoading(true);
    setFetchError(null);
    try {
      const q = query(collection(db, 'gameSlots'), where('userId', '==', user.uid));
      const snap = await getDocs(q);
      const loaded = { 1: null, 2: null, 3: null, 4: null };
      snap.docs.forEach(d => {
        var data = d.data();
        // Validate slot data - skip corrupted entries
        if (data && data.slot && data.brand) {
          loaded[data.slot] = { id: d.id, ...data };
        } else {
          console.warn('Corrupted slot data skipped:', d.id, data);
        }
      });
      setSlots(loaded);
    } catch (e) {
      console.error('Failed to load slots:', e);
      setFetchError(e.code === 'unavailable' ? 'offline' : 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCustomBrands = async () => {
    try {
      const q = query(collection(db, 'customBrands'), where('userId', '==', user.uid));
      const snap = await getDocs(q);
      const brands = snap.docs.map(d => ({ ...d.data(), _docId: d.id }));
      setCustomBrands(brands);
    } catch (e) {
      console.error('Failed to load custom brands:', e);
    }
  };

  const fetchCustomGMs = async () => {
    try {
      const q = query(collection(db, 'customGMs'), where('userId', '==', user.uid));
      const snap = await getDocs(q);
      const gms = snap.docs.map(d => ({ ...d.data(), _docId: d.id }));
      setCustomGMs(gms);
    } catch (e) {
      console.error('Failed to load custom GMs:', e);
    }
  };

  const saveCustomBrand = async (brandData) => {
    try {
      const dataToSave = {
        userId: user.uid,
        name: brandData.name,
        color: brandData.color,
        bg: brandData.bg || null,
        logo: brandData.logo || null,
        isCustom: true,
        championships: brandData.championships || {},
        customTitles: brandData.customTitles || [],
        createdAt: new Date(),
      };
      const docRef = await addDoc(collection(db, 'customBrands'), dataToSave);
      return { ...dataToSave, _docId: docRef.id };
    } catch (e) {
      console.error('Failed to save custom brand:', e);
      return null;
    }
  };

  const deleteCustomBrandFromDb = async (docId) => {
    try {
      await deleteDoc(doc(db, 'customBrands', docId));
    } catch (e) {
      console.error('Failed to delete custom brand:', e);
    }
  };

  const saveCustomGM = async (gmData) => {
    try {
      const dataToSave = {
        userId: user.uid,
        name: gmData.name,
        img: gmData.imgPreview || gmData.img || null,
        createdAt: new Date(),
      };
      const docRef = await addDoc(collection(db, 'customGMs'), dataToSave);
      return { ...dataToSave, _docId: docRef.id };
    } catch (e) {
      console.error('Failed to save custom GM:', e);
      return null;
    }
  };

  const deleteCustomGMFromDb = async (docId) => {
    try {
      await deleteDoc(doc(db, 'customGMs', docId));
    } catch (e) {
      console.error('Failed to delete custom GM:', e);
    }
  };

  // Base game roster only (wrestlers_2k25 / wrestlers_2k26). No version selected yet = empty.
  const fetchOfficialWrestlers = async (version) => {
    try {
      var collectionName = version === '2k25' ? 'wrestlers_2k25' : version === '2k26' ? 'wrestlers_2k26' : null;
      if (!collectionName) { setBaseRoster([]); return; }
      const snap = await getDocs(collection(db, collectionName));
      var loaded = snap.docs.map(d => {
        var data = d.data();
        return {
          id: d.id,
          ...data,
          promo_level: data.promo_level !== undefined ? data.promo_level : (data.promo_skill || 0),
          starting_xp: data.starting_xp !== undefined ? data.starting_xp : 0,
        };
      });
      setBaseRoster(loaded);
    } catch (e) {
      console.error('Failed to load wrestlers:', e);
    }
  };

  // Superstars created manually via Settings → Custom Content — private to this user.
  const fetchCustomWrestlers = async () => {
    try {
      const q = query(collection(db, 'officialWrestlers'), where('userId', '==', user.uid));
      const snap = await getDocs(q);
      setCustomWrestlers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) {
      console.error('Failed to load custom wrestlers:', e);
    }
  };

  // Merge base roster + private custom wrestlers + private stars.json imports into a single pool,
  // deduped by wrestler_id, whenever any of the three sources change.
  useEffect(() => {
    var merged = [...baseRoster];
    var seen = new Set(merged.map(function(w) { return String(w.wrestler_id); }));
    [...customWrestlers, ...existingImports].forEach(function(w) {
      var id = String(w.wrestler_id);
      if (!seen.has(id)) { merged.push(w); seen.add(id); }
    });
    setOfficialWrestlers(merged);
    try { sessionStorage.setItem('officialWrestlers', JSON.stringify(merged)); } catch(e) {}
  }, [baseRoster, customWrestlers, existingImports]);

  const goToReview = (roster) => {
    setReviewRoster(roster);
    setShowReview(true);
  };

  const goToDraft = (roster) => {
    setDraftRoster(roster);
    setShowReview(false);
    setShowDraft(true);
  };

  const finishGame = async (draftedPicks) => {
    const isOfficialBrand = OFFICIAL_BRANDS.find(b => b.name === selectedBrand.name);
    const id = user.uid + '_slot' + selectedSlot;
    // Find GM render (official or custom)
    const customGMObj = customGMs.find(g => g.name === selectedGM);
    const gmRender = customGMObj ? (customGMObj.img || customGMObj.render || null) : null;
    
    // Find rivals' custom GM renders too
    const rivalsWithRenders = (gameSettingsData.rivals || []).filter(Boolean).map(function(r) {
      const rCustomGM = customGMs.find(g => g.name === r.gm);
      const rCustomBrand = customBrands.find(b => b.name === r.brand);
      return {
        ...r,
        fans: 1000000,
        gmRender: rCustomGM ? (rCustomGM.img || rCustomGM.render || null) : null,
        brandIsCustom: !!rCustomBrand,
        brandLogo: rCustomBrand ? rCustomBrand.logo : null,
        brandBg: rCustomBrand ? rCustomBrand.bg : null,
        brandColor: rCustomBrand ? rCustomBrand.color : null,
      };
    });
    
    const gameData = {
  id, userId: user.uid, userEmail: user.email || null, slot: Number(selectedSlot), slotName: slotNames[selectedSlot] || ('Slot ' + selectedSlot),
      brand: selectedBrand.name, brandColor: selectedBrand.color,
      brandIsCustom: !isOfficialBrand,
      brandLogo: !isOfficialBrand ? selectedBrand.logo : null,
      brandBg: !isOfficialBrand ? selectedBrand.bg : null,
      gm: selectedGM, gmRender, roster: draftedPicks, champions: {}, ...gameSettingsData,
      gameVersion: gameVersion || 'legacy',
      createdAt: new Date(), week: 1, season: 1, budget: gameSettingsData.budget || 3000000,
      fans: 1000000, nextPle: null,
      logisticsTokens: 1,
      logistics: { arena: 1, crew: 1, sfx: 1, advertising: 1 },
      logisticsOwned: { arena: [1], crew: [1], sfx: [1], advertising: [1] },
      _officialWrestlers: officialWrestlers.filter(function(w) { return w.status !== 'gm'; }),
      rivals: rivalsWithRenders,
    };
    // Sanitize before save
    const sanitized = JSON.parse(JSON.stringify(gameData, function(key, val) {
      if (typeof val === 'function') return undefined;
      return val;
    }));
    await setDoc(doc(db, 'gameSlots', id), sanitized);
    setShowDraft(false);
    setShowSetChampions(false);
    setStep('slots'); setSelectedSlot(null); setSelectedBrand(null);
    setSelectedGM(null); setRosterMode(null); setSelectedWrestlers([]);
    setDraftRoster([]);
    // Enter the game directly with week start popup
    onEnterGame({ ...gameData, _showWeekStart: true, _pendingSetChampions: true });
  };

  const handleDeleteSlot = async () => {
    await deleteDoc(doc(db, 'gameSlots', deleteTarget.id));
    setDeleteTarget(null);
    fetchSlots();
  };

  const allBrands = [...OFFICIAL_BRANDS, ...customBrands];

  // Maps for rival cards
  const BRAND_LOGOS_MAP = { 'Raw': logoRaw, 'SmackDown': logoSmackDown, 'NXT': logoNXT, 'NXT 2.0': logoNXT20, 'WCW': logoWCW, 'ECW': logoECW, 'NXT Mutiny': logoNXTMutiny };
  const BRAND_BGS_MAP = { 'Raw': bgRaw, 'SmackDown': bgSmackDown, 'NXT': bgNXT, 'NXT 2.0': bgNXT20, 'WCW': bgWCW, 'ECW': bgECW, 'NXT Mutiny': bgNXTMutiny };
  const GM_RENDERS_MAP = { 'Adam Pearce': gmAdamPearce, 'Nick Aldis': gmNickAldis, 'Shawn Michaels': gmShawnMichaels, 'Ava': gmAva, 'Stephanie McMahon': gmStephanie, 'Paul Heyman': gmPaulHeyman, 'William Regal': gmWilliamRegal, 'Mick Foley': gmMickFoley, 'Teddy Long': gmTeddyLong, 'Eric Bischoff': gmEricBischoff, 'Sensational Sherri': gmSherri, 'Miss Elizabeth': gmMissElizabeth, 'Mr Fuji': gmMrFuji, 'Bobby Heenan': gmBobbyHeenan, 'CM Punk': gmCMPunk, 'Xavier Woods': gmXavierWoods, 'Tyler Breeze': gmTylerBreeze, 'Stacy Keibler': gmStacyKeibler, 'Anonymous GM': gmAnonymousGM };
  const placeholderGm = placeholderImg;
  const allGMs = [...GM_LIST, ...customGMs];

  // ── GAME SETTINGS
  if (showGameSettings) return (
    <GameSettings
      brand={selectedBrand?.name}
      gm={selectedGM}
      initialSettings={gameSettingsData}
      onBack={() => setShowGameSettings(false)}
      onConfirm={(settings) => {
        setGameSettingsData(settings);
        setSettingsConfirmed(true);
        setShowGameSettings(false);
        if (rosterMode === 'custom') setShowCustomRosterManager(true);
        else if (rosterMode === 'default') goToReview(officialWrestlers.filter(function(w) { return w.status !== 'gm'; }));
      }}
    />
  );

  // ── REVIEW PAGE
  if (showReview) return (
    <RosterReview
      roster={reviewRoster}
      brand={selectedBrand?.name}
      customLogo={selectedBrand?.isCustom ? selectedBrand.logo : null}
      customBg={selectedBrand?.isCustom ? selectedBrand.bg : null}
      customColor={selectedBrand?.isCustom ? selectedBrand.color : null}
      customGMs={customGMs}
      onBack={() => setShowReview(false)}
      onConfirm={() => goToDraft(reviewRoster)}
    />
  );

  // ── SET CHAMPIONS
  // ── FINAL REVIEW
  if (showFinalReview) return (
    <RosterReview
      roster={finalRoster}
      brand={selectedBrand?.name}
      gm={selectedGM}
      isFinal={true}
      customLogo={selectedBrand?.isCustom ? selectedBrand.logo : null}
      customBg={selectedBrand?.isCustom ? selectedBrand.bg : null}
      customColor={selectedBrand?.isCustom ? selectedBrand.color : null}
      customGMs={customGMs}
      onBack={() => { setShowFinalReview(false); setShowDraft(true); }}
      onConfirm={() => finishGame(finalRoster)}
    />
  );

  // ── DRAFT PAGE
  if (showDraft) return (
    <DraftPage
      roster={draftRoster}
      brand={selectedBrand?.name}
      customLogo={selectedBrand?.isCustom ? selectedBrand.logo : null}
      customBg={selectedBrand?.isCustom ? selectedBrand.bg : null}
      customColor={selectedBrand?.isCustom ? selectedBrand.color : null}
      onBack={() => setShowDraft(false)}
      onFinish={(picks) => { setFinalRoster(picks); setShowDraft(false); setShowFinalReview(true); }}
    />
  );

  // ── PAGE: SLOTS ────────────────────────────────────────────────────
  if (step === 'slots') return (
    <div style={pageStyle}>
      <style>{css}</style>
      <div style={overlayStyle} />
      {deleteTarget && (
        <DeleteConfirmPopup
          title={`DELETE SLOT ${deleteTarget.slot}?`}
          subtitle={`${deleteTarget.brand} — ${deleteTarget.gm}`}
          onClose={() => setDeleteTarget(null)}
          onConfirm={handleDeleteSlot}
        />
      )}
      <div style={{ position: 'relative', zIndex: 2, width: '100%', maxWidth: '900px', padding: '80px 20px 0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '28px' }}>
          <LogoPlaceholder />
          <div style={{ ...titleSt, fontSize: '1.4rem' }}>GM SLOTS</div>
        </div>
        <div style={{ ...panel, padding: '28px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '22px' }}>
            {[1, 2, 3, 4].map(n => {
              // Loading state
              if (isLoading) return (
                <div key={n} style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.06)', minHeight: '460px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(8,8,8,0.5)' }}>
                  <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.2)', letterSpacing: '2px' }}>LOADING...</div>
                </div>
              );
              const game = slots[n];
              const isSelected = selectedSlot === n && !game;
              // Check custom brands first, then official
              const brandData = game ? (
                customBrands.find(b => b.name === game.brand) ||
                OFFICIAL_BRANDS.find(b => b.name === game.brand) ||
                (game.brandLogo || game.brandBg ? { logo: game.brandLogo, bg: game.brandBg, name: game.brand } : null)
              ) : null;
              // Check custom GMs first, then official  
              const gmData = game ? (
                customGMs.find(g => g.name === game.gm) ||
                GM_LIST.find(g => g.name === game.gm) ||
                (game.gmRender ? { name: game.gm, img: game.gmRender } : null)
              ) : null;
              return (
                <div key={n}
                  className={`slot-card${isSelected ? ' selected' : ''}`}
                  onClick={() => !game && setSelectedSlot(n)}
                  style={{ borderRadius: '10px', overflow: 'hidden', cursor: game ? 'default' : 'pointer', outline: isSelected ? '2px solid rgba(255,255,255,0.75)' : '1px solid rgba(255,255,255,0.1)', minHeight: '460px', position: 'relative', display: 'flex', flexDirection: 'column' }}>
                  {game ? (
                    <>
                      {brandData?.bg && (
                        <img loading="lazy" className="slot-bg" src={brandData.bg} alt=""
                          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
                      )}
                      {!brandData?.bg && <div style={{ position: 'absolute', inset: 0, background: game.brandColor ? `${game.brandColor}44` : '#111', zIndex: 0 }} />}
                      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.05) 35%, rgba(0,0,0,0.7) 70%, rgba(0,0,0,0.93) 100%)', zIndex: 1 }} />
                      {gmData?.img && (
                        <img loading="lazy" src={gmData.img} alt={game.gm}
                          style={{ position: 'absolute', bottom: '196px', left: 0, right: 0, top: 0, width: '100%', height: 'calc(100% - 196px)', objectFit: 'cover', objectPosition: 'top center', zIndex: 2 }} />
                      )}
                      <div style={{ position: 'absolute', bottom: '204px', left: 0, right: 0, display: 'flex', justifyContent: 'center', padding: '0', zIndex: 3 }}>
                        {brandData?.logo
                          ? <img loading="lazy" src={brandData.logo} alt={game.brand} style={{ height: '56px', objectFit: 'contain', filter: 'drop-shadow(0 2px 14px rgba(0,0,0,0.95))' }} />
                          : <div style={{ fontFamily: "'Anton', sans-serif", fontSize: '0.85rem', letterSpacing: '2px', color: '#fff', textShadow: `0 0 14px ${game.brandColor}` }}>{game.brand}</div>
                        }
                      </div>
                      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 3, padding: '10px 14px 12px', background: 'rgba(0,0,0,0.85)', borderTop: `1px solid ${game.brandColor || '#333'}55`, height: '196px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column' }}>
                        {/* Slot name */}
                        {game.slotName && (
                          <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.55rem', letterSpacing: '2px', color: game.brandColor || '#d4af37', marginBottom: '2px', textTransform: 'uppercase', opacity: 0.8, flexShrink: 0 }}>{game.slotName}</div>
                        )}
                        {/* GM name */}
                        <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.52rem', color: 'rgba(255,255,255,0.45)', letterSpacing: '0.5px', marginBottom: '6px', textTransform: 'uppercase', flexShrink: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{game.gm}</div>
                        {/* Stats grid — fixed height, no wrapping */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 8px', marginBottom: '8px', flexShrink: 0 }}>
                          {[
                            ['WEEK', game.week || 1],
                            ['NEXT PLE', (game.nextPle && ((PLES.find(p => p.id === game.nextPle) || {}).name || '').toUpperCase()) || '—'],
                            ['FANS', (game.fans || 1000000).toLocaleString('fr-FR')],
                            ['BUDGET', '$' + ((game.budget || 0) / 1000000).toFixed(1) + 'M'],
                          ].map(([label, val]) => (
                            <div key={label} style={{ overflow: 'hidden' }}>
                              <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.42rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '1px' }}>{label}</div>
                              <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.52rem', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.3' }}>{val}</div>
                            </div>
                          ))}
                        </div>
                        {/* Rival logos */}
                        {game.rivals && game.rivals.filter(Boolean).length > 0 && (
                          <div style={{ display: 'flex', gap: '6px', alignItems: 'center', marginBottom: '8px' }}>
                            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.38rem', color: 'rgba(255,255,255,0.25)', letterSpacing: '1px', flexShrink: 0 }}>RIVALS</div>
                            {game.rivals.filter(Boolean).map((rival, ri) => {
                              const rBrandObj = rival.brand ? (customBrands.find(b => b.name === rival.brand) || OFFICIAL_BRANDS.find(b => b.name === rival.brand)) : null;
                              const rLogo = rBrandObj?.logo || BRAND_LOGOS_MAP[rival.brand] || null;
                              return rLogo ? (
                                <img loading="lazy" key={ri} src={rLogo} alt={rival.brand} title={rival.brand}
                                  style={{ height: '18px', objectFit: 'contain', filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.9)) brightness(0.8)' }} />
                              ) : (
                                <div key={ri} style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.38rem', color: 'rgba(255,255,255,0.4)', background: 'rgba(255,255,255,0.06)', padding: '2px 5px', borderRadius: '2px' }}>{rival.brand}</div>
                              );
                            })}
                          </div>
                        )}
                        {/* Buttons */}
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button className="btn-wwe"
                            onClick={e => { e.stopPropagation(); onEnterGame({ ...game, _showWelcomeBack: true }); }}
                            style={{ ...btnSt, flex: 1, fontSize: '0.5rem', padding: '5px 8px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                            <PlayArrowIcon style={{ fontSize: 11 }} /> PLAY
                          </button>
                          <button className="btn-wwe"
                            onClick={e => { e.stopPropagation(); setDeleteTarget(game); }}
                            style={{ ...btnSt, fontSize: '0.5rem', padding: '5px 10px', borderColor: 'rgba(231,76,60,0.4)', color: 'rgba(231,76,60,0.7)', display: 'flex', alignItems: 'center' }}>
                            <DeleteOutlineIcon style={{ fontSize: 13 }} />
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '10px', background: isSelected ? 'rgba(255,255,255,0.05)' : 'rgba(8,8,8,0.7)', minHeight: '460px' }}>
                      {editingSlotName === n ? (
                        <input
                          autoFocus
                          value={slotNames[n]}
                          onChange={e => setSlotNames(p => ({ ...p, [n]: e.target.value }))}
                          onBlur={() => setEditingSlotName(null)}
                          onKeyDown={e => e.key === 'Enter' && setEditingSlotName(null)}
                          onClick={e => e.stopPropagation()}
                          maxLength={20}
                          style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '4px', padding: '4px 10px', color: '#fff', fontSize: '0.6rem', fontFamily: "'Monda',sans-serif", outline: 'none', textAlign: 'center', width: '80%' }}
                        />
                      ) : (
                        <div
                          onClick={e => { e.stopPropagation(); setEditingSlotName(n); }}
                          style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.6rem', letterSpacing: '2px', color: slotNames[n] ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.2)', cursor: 'text', borderBottom: '1px dashed rgba(255,255,255,0.15)', padding: '2px 8px', minWidth: '80px', textAlign: 'center' }}>
                          {slotNames[n] || 'SLOT ' + n}
                        </div>
                      )}
                      <AddCircleOutlineIcon style={{ fontSize: 36, color: 'rgba(255,255,255,0.15)' }} />
                      <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.52rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.15)' }}>NEW SLOT</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <button className="btn-wwe"
              style={{ ...btnSt, borderColor: selectedSlot ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.18)', color: selectedSlot ? '#fff' : 'rgba(255,255,255,0.25)' }}
              onClick={() => selectedSlot && setStep('brand')} disabled={!selectedSlot}>
              CONFIRM
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  // ── PAGE: BRAND ────────────────────────────────────────────────────
  if (step === 'brand') return (
    <div style={pageStyle}>
      <style>{css}</style>
      <div style={overlayStyle} />
      {showCustomBrand && (
        <CustomBrandPopup
          user={user}
          onClose={() => setShowCustomBrand(false)}
          onConfirm={async (form) => {
            const brandData = {
              name: form.name,
              color: form.color,
              bg: form.bgPreview || null,
              logo: form.logoPreview || null,
              championships: form.championships || {},
              customTitles: form.customTitles || [],
            };
            const saved = await saveCustomBrand(brandData);
            if (saved) {
              setCustomBrands(p => [...p, saved]);
            } else {
              // Fallback: still add locally if Firestore fails
              setCustomBrands(p => [...p, { ...brandData, isCustom: true }]);
            }
            setShowCustomBrand(false);
          }}
        />
      )}
      {deleteCustomBrand !== null && (
        <DeleteConfirmPopup
          title="DELETE CUSTOM BRAND?"
          subtitle={customBrands[deleteCustomBrand]?.name}
          onClose={() => setDeleteCustomBrand(null)}
          onConfirm={async () => {
            const brandToDelete = customBrands[deleteCustomBrand];
            if (brandToDelete?._docId) {
              await deleteCustomBrandFromDb(brandToDelete._docId);
            }
            setCustomBrands(p => p.filter((_, i) => i !== deleteCustomBrand));
            if (selectedBrand?.name === customBrands[deleteCustomBrand]?.name) setSelectedBrand(null);
            setDeleteCustomBrand(null);
          }}
        />
      )}
      <div style={{ position: 'relative', zIndex: 2, width: '100%', maxWidth: '900px', padding: '80px 20px 0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '28px' }}>
          <LogoPlaceholder />
          <div style={{ ...titleSt, fontSize: '1.4rem' }}>CHOOSE YOUR BRAND</div>
        </div>
        <div style={{ ...panel, padding: '28px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '22px' }}>
            {allBrands.map((brand, i) => {
              const isSelected = selectedBrand?.name === brand.name;
              const isCustom = brand.isCustom;
              const customIdx = customBrands.findIndex(b => b.name === brand.name);
              return (
                <div key={i} style={{ position: 'relative' }}>
                  <div
                    className={`brand-card${isSelected ? ' selected' : ''}${isCustom ? ' custom-card' : ''}`}
                    onClick={() => setSelectedBrand(brand)}
                    style={{ borderRadius: '10px', minHeight: '120px', cursor: 'pointer', overflow: 'hidden', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', outline: isSelected ? '2px solid rgba(255,255,255,0.8)' : '1px solid rgba(255,255,255,0.08)' }}>
                    {brand.bg && (
                      <img loading="lazy" className="brand-bg" src={brand.bg} alt=""
                        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                    )}
                    {!brand.bg && <div style={{ position: 'absolute', inset: 0, background: `${brand.color}22` }} />}
                    <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.25)' }} />
                    {brand.logo
                      ? <img loading="lazy" src={brand.logo} alt={brand.name}
                          style={{ width: '75%', maxHeight: '65px', objectFit: 'contain', position: 'relative', zIndex: 2, filter: 'drop-shadow(0 2px 10px rgba(0,0,0,0.9))' }} />
                      : <div style={{ fontFamily: "'Anton', sans-serif", fontSize: '0.95rem', letterSpacing: '2px', color: '#fff', textAlign: 'center', padding: '16px', position: 'relative', zIndex: 2, textShadow: `0 0 18px ${brand.color}` }}>{brand.name}</div>
                    }
                    {/* Delete button for custom brands */}
                    {isCustom && (
                      <button className="delete-btn"
                        onClick={e => { e.stopPropagation(); setDeleteCustomBrand(customIdx); }}
                        style={{ position: 'absolute', top: '6px', right: '6px', zIndex: 3, background: 'rgba(0,0,0,0.7)', border: '1px solid rgba(231,76,60,0.5)', borderRadius: '50%', width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#e74c3c' }}>
                        <CloseIcon style={{ fontSize: 12 }} />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
            {/* Custom brand button */}
            <div className="hover-outline"
              onClick={() => setShowCustomBrand(true)}
              style={{ ...panel, minHeight: '120px', cursor: 'pointer', outline: '1.5px solid transparent', transition: 'outline 0.15s', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.02)' }}>
              <div style={{ textAlign: 'center' }}>
                <AddCircleOutlineIcon style={{ fontSize: 28, color: 'rgba(255,255,255,0.2)', display: 'block', margin: '0 auto 6px' }} />
                <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.58rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.28)' }}>CUSTOM BRAND</div>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <button className="btn-wwe"
              style={{ ...btnSt, color: 'rgba(255,255,255,0.35)', borderColor: 'rgba(255,255,255,0.15)' }}
              onClick={() => { setStep('slots'); setSelectedBrand(null); }}>
              ← BACK
            </button>
            <button className="btn-wwe"
              style={{ ...btnSt, borderColor: selectedBrand ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.18)', color: selectedBrand ? '#fff' : 'rgba(255,255,255,0.25)' }}
              onClick={() => selectedBrand && setStep('gm')} disabled={!selectedBrand}>
              CONFIRM
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  // ── PAGE: GM + ROSTER ──────────────────────────────────────────────
  if (step === 'gm') return (
    <div style={{ ...pageStyle, overflowY: 'auto' }}>
      <style>{css}</style>
      {selectedBrand?.bg && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 0, overflow: 'hidden' }}>
          <img loading="lazy" src={selectedBrand.bg} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(12px) brightness(0.3)', transform: 'scale(1.1)' }} />
        </div>
      )}
      <div style={overlayStyle} />
      {showCustomGM && (
        <CustomGMPopup onClose={() => setShowCustomGM(false)}
          onConfirm={async (gmData) => {
            const saved = await saveCustomGM(gmData);
            if (saved) {
              setCustomGMs(p => [...p, saved]);
            } else {
              setCustomGMs(p => [...p, { name: gmData.name, img: gmData.imgPreview || null }]);
            }
            setShowCustomGM(false);
          }} />
      )}
      {deleteCustomGM !== null && (
        <DeleteConfirmPopup title="DELETE CUSTOM GM?" subtitle={customGMs[deleteCustomGM]?.name}
          onClose={() => setDeleteCustomGM(null)}
          onConfirm={async () => {
            const gmToDelete = customGMs[deleteCustomGM];
            if (gmToDelete?._docId) {
              await deleteCustomGMFromDb(gmToDelete._docId);
            }
            setCustomGMs(p => p.filter((_, i) => i !== deleteCustomGM));
            if (selectedGM === customGMs[deleteCustomGM]?.name) setSelectedGM(null);
            setDeleteCustomGM(null);
          }} />
      )}
      {showCustomRosterManager && (
        <CustomRosterManager user={user} wrestlers={officialWrestlers} brand={selectedBrand?.name}
          onClose={() => setShowCustomRosterManager(false)}
          onConfirm={(roster) => { setShowCustomRosterManager(false); goToReview(roster); }} />
      )}
      {showImport && (
        <ImportRosterFlow
          onClose={() => setShowImport(false)}
          officialWrestlers={officialWrestlers}
          userId={user && user.uid}
          onImport={(roster, rosterName) => { setExistingImports(prev => [...prev, ...roster.filter(w => w.isOfficial === 'imported')]); setShowImport(false); var base = officialWrestlers.filter(function(w) { return w.status !== 'gm'; }); goToReview([...base, ...roster]); }} />
      )}

      <div style={{ position: 'relative', zIndex: 2, width: '100%', maxWidth: '960px', padding: '80px 20px 40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {/* Title */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          {selectedBrand?.logo ? <img loading="lazy" src={selectedBrand.logo} alt={selectedBrand.name} style={{ height: '48px', objectFit: 'contain', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.8))' }} /> : <LogoPlaceholder />}
          <div style={{ ...titleSt, fontSize: '1.4rem' }}>CHOOSE YOUR GM / ROSTER</div>
        </div>

        {/* ── GM SECTION ── */}
        <div style={{ ...panel, padding: '20px 24px' }}>
          <div style={{ fontFamily: "'Anton',sans-serif", letterSpacing: '2px', color: '#fff', fontSize: '0.85rem', marginBottom: '14px', textShadow: '0 0 18px rgba(180,0,0,0.4)' }}>GENERAL MANAGER</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '10px' }}>
            {allGMs.map((gm, i) => {
              const isSelected = selectedGM === gm.name;
              const customIdx = customGMs.findIndex(g => g.name === gm.name);
              return (
                <div key={i} style={{ position: 'relative' }}>
                  <div className={`gm-card${isSelected ? ' selected' : ''}${customIdx >= 0 ? ' custom-card' : ''}`}
                    onClick={() => setSelectedGM(gm.name)}
                    style={{ borderRadius: '8px', cursor: 'pointer', outline: isSelected ? '2px solid rgba(255,255,255,0.75)' : '1px solid rgba(255,255,255,0.07)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', overflow: 'hidden', background: 'rgba(8,8,8,0.7)', minHeight: '120px', position: 'relative' }}>
                    {selectedBrand?.bg && <img loading="lazy" className="gm-bg" src={selectedBrand.bg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />}
                    {gm.img || gm.imgPreview
                      ? <img loading="lazy" className="gm-render" src={gm.img || gm.imgPreview} alt={gm.name} style={{ width: '100%', height: '95px', objectFit: 'cover', objectPosition: 'top center', position: 'relative', zIndex: 1 }} />
                      : <div style={{ width: '100%', height: '95px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', position: 'relative', zIndex: 1 }}><div style={{ width: '44px', height: '72px', background: 'rgba(255,255,255,0.06)', borderRadius: '22px 22px 0 0' }} /></div>}
                    <div style={{ padding: '5px 5px 7px', textAlign: 'center', background: isSelected ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.6)', width: '100%', position: 'relative', zIndex: 1 }}>
                      <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.48rem', letterSpacing: '0.5px', color: isSelected ? '#fff' : 'rgba(255,255,255,0.55)', lineHeight: '1.3' }}>{gm.name}</div>
                    </div>
                    {customIdx >= 0 && (
                      <button className="delete-btn" onClick={e => { e.stopPropagation(); setDeleteCustomGM(customIdx); }}
                        style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 3, background: 'rgba(0,0,0,0.7)', border: '1px solid rgba(231,76,60,0.5)', borderRadius: '50%', width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#e74c3c' }}>
                        <CloseIcon style={{ fontSize: 11 }} />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
            <div className="hover-outline" onClick={() => setShowCustomGM(true)}
              style={{ ...panel, minHeight: '120px', cursor: 'pointer', outline: '1.5px solid transparent', transition: 'background 0.2s, border-color 0.2s, color 0.2s', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '6px', background: 'rgba(255,255,255,0.02)' }}>
              <AddCircleOutlineIcon style={{ fontSize: 24, color: 'rgba(255,255,255,0.2)' }} />
              <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.48rem', letterSpacing: '1px', color: 'rgba(255,255,255,0.25)', textAlign: 'center' }}>CUSTOM GM</div>
            </div>
          </div>
        </div>

        {/* ── SETTINGS + RIVALS (2 colonnes) ── */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>

          {/* SETTINGS */}
          <div style={{ ...panel, padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: '18px' }}>
            <div style={{ fontFamily: "'Anton',sans-serif", letterSpacing: '2px', color: '#fff', fontSize: '0.85rem', textShadow: '0 0 18px rgba(180,0,0,0.4)' }}>SETTINGS</div>

            {/* Budget */}
            <div>
              <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.46rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '8px' }}>STARTING BUDGET</div>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                {[3000000, 4000000, 5000000, 6000000, 7000000].map(val => (
                  <button key={val} className="btn-wwe"
                    onClick={() => setGameSettingsData(p => ({ ...p, budget: val }))}
                    style={{ ...btnSt, flex: 1, fontSize: '0.58rem', padding: '7px 10px', borderColor: (gameSettingsData.budget || 3000000) === val ? 'rgba(255,255,255,0.65)' : 'rgba(255,255,255,0.2)', color: (gameSettingsData.budget || 3000000) === val ? '#fff' : 'rgba(255,255,255,0.4)', background: (gameSettingsData.budget || 3000000) === val ? 'rgba(255,255,255,0.07)' : 'transparent' }}>
                    {`$${val/1000000}M`}
                  </button>
                ))}
              </div>
              {/* Custom budget input */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '1px', flexShrink: 0 }}>CUSTOM</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '5px', padding: '6px 10px' }}>
                  <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.5rem', color: 'rgba(255,255,255,0.35)' }}>$</span>
                  <input
                    type="number"
                    min="0"
                    step="100000"
                    placeholder="Enter amount..."
                    value={[3000000, 4000000, 5000000, 6000000, 7000000].includes(gameSettingsData.budget || 3000000) ? '' : (gameSettingsData.budget || '')}
                    onChange={e => {
                      var val = Number(e.target.value);
                      if (!isNaN(val) && val >= 0) setGameSettingsData(p => ({ ...p, budget: val }));
                    }}
                    style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.75rem', background: 'transparent', border: 'none', color: '#fff', outline: 'none', flex: 1, letterSpacing: '1px' }}
                  />
                  {![3000000, 4000000, 5000000, 6000000, 7000000].includes(gameSettingsData.budget || 3000000) && gameSettingsData.budget > 0 && (
                    <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.42rem', color: '#2ecc71' }}>
                      ${((gameSettingsData.budget || 0) / 1000000).toFixed(2)}M
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Difficulty */}
            <div>
              <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.46rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '8px' }}>DIFFICULTY</div>
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                {[
                  { key: 'easy', label: 'EASY', color: '#2ecc71' },
                  { key: 'normal', label: 'NORMAL', color: '#3498db' },
                  { key: 'hard', label: 'HARD', color: '#e67e22' },
                  { key: 'extreme', label: 'EXTREME', color: '#e74c3c' },
                  { key: 'immortal', label: 'IMMORTAL', color: '#9b59b6' },
                ].map(({ key, label, color }) => {
                  const isActive = (gameSettingsData.difficulty || 'normal') === key;
                  return (
                    <button key={key} className="btn-wwe"
                      onClick={() => setGameSettingsData(p => ({ ...p, difficulty: key }))}
                      style={{ ...btnSt, fontSize: '0.48rem', padding: '6px 12px', borderColor: isActive ? color : 'rgba(255,255,255,0.15)', color: isActive ? color : 'rgba(255,255,255,0.35)', background: isActive ? `${color}18` : 'transparent' }}>
                      {label}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Match type */}
            <div>
              <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.46rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '8px' }}>TYPE DE MATCH</div>
              <div style={{ display: 'flex', gap: '8px' }}>
                {[{ key: 'classic', label: 'CLASSIQUE' }, { key: 'unlock', label: 'À DÉBLOQUER' }].map(({ key, label }) => (
                  <button key={key} className="btn-wwe"
                    onClick={() => setGameSettingsData(p => ({ ...p, matchType: key }))}
                    style={{ ...btnSt, flex: 1, fontSize: '0.5rem', padding: '7px 8px', borderColor: (gameSettingsData.matchType || 'classic') === key ? 'rgba(255,255,255,0.65)' : 'rgba(255,255,255,0.2)', color: (gameSettingsData.matchType || 'classic') === key ? '#fff' : 'rgba(255,255,255,0.4)', background: (gameSettingsData.matchType || 'classic') === key ? 'rgba(255,255,255,0.07)' : 'transparent' }}>
                    {label}
                  </button>
                ))}
              </div>
            </div>

            {/* HoF Trophies */}
            <div>
              <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.46rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '8px' }}>HALL OF FAME TROPHIES</div>
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                {[1, 10, 15, 20, 25, 30].map(val => (
                  <button key={val} className="btn-wwe"
                    onClick={() => setGameSettingsData(p => ({ ...p, hofTrophies: val }))}
                    style={{ ...btnSt, padding: '6px 12px', fontSize: '0.55rem', borderColor: (gameSettingsData.hofTrophies || 10) === val ? 'rgba(255,255,255,0.65)' : 'rgba(255,255,255,0.2)', color: (gameSettingsData.hofTrophies || 10) === val ? '#fff' : 'rgba(255,255,255,0.4)', background: (gameSettingsData.hofTrophies || 10) === val ? 'rgba(255,255,255,0.07)' : 'transparent' }}>
                    {val}
                  </button>
                ))}
              </div>
            </div>

            {/* Victory criteria */}
            <div>
              <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.46rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '8px' }}>VICTORY CRITERIA</div>
              <div style={{ display: 'flex', gap: '8px' }}>
                {[{ key: 'fans', label: 'FANS' }, { key: 'hof', label: 'HOF TROPHIES' }].map(({ key, label }) => (
                  <button key={key} className="btn-wwe"
                    onClick={() => setGameSettingsData(p => ({ ...p, victoryCriteria: key }))}
                    style={{ ...btnSt, flex: 1, fontSize: '0.5rem', padding: '7px 8px', borderColor: (gameSettingsData.victoryCriteria || 'fans') === key ? 'rgba(255,255,255,0.65)' : 'rgba(255,255,255,0.2)', color: (gameSettingsData.victoryCriteria || 'fans') === key ? '#fff' : 'rgba(255,255,255,0.4)', background: (gameSettingsData.victoryCriteria || 'fans') === key ? 'rgba(255,255,255,0.07)' : 'transparent' }}>
                    {label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* RIVALS */}
          <div style={{ ...panel, padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontFamily: "'Anton',sans-serif", letterSpacing: '2px', color: '#fff', fontSize: '0.85rem', textShadow: '0 0 18px rgba(180,0,0,0.4)' }}>RIVALS</div>
              <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.42rem', color: (gameSettingsData.rivals || []).filter(Boolean).length >= 1 ? '#2ecc71' : 'rgba(231,76,60,0.7)', letterSpacing: '0.5px' }}>{(gameSettingsData.rivals || []).filter(Boolean).length >= 1 ? '✓ SET' : '⚠ MIN. 1 REQUIRED'}</div>
            </div>
            <div style={{ display: 'flex', gap: '10px', flex: 1 }}>
              {(gameSettingsData.rivals || [null, null, null]).map((rival, i) => {
                const rivalBrandObj = allBrands.find(b => b.name === rival?.brand);
                const rBrandLogo = rivalBrandObj?.logo || BRAND_LOGOS_MAP[rival?.brand] || null;
                const rBrandBg = rivalBrandObj?.bg || BRAND_BGS_MAP[rival?.brand] || null;
                const rBrandColor = rivalBrandObj?.color || BRAND_COLORS[rival?.brand] || '#444';
                const rivalGmObj = allGMs.find(g => g.name === rival?.gm);
                const rGmRender = rivalGmObj?.img || rivalGmObj?.imgPreview || GM_RENDERS_MAP[rival?.gm] || null;
                return (
                  <div key={i}
                    onClick={() => setRivalPickerIdx(i)}
                    style={{ flex: 1, borderRadius: '8px', overflow: 'hidden', border: `1px solid ${rival ? rBrandColor + '55' : 'rgba(255,255,255,0.08)'}`, position: 'relative', height: '260px', cursor: 'pointer', background: rival ? 'rgba(8,8,8,0.8)' : 'rgba(255,255,255,0.02)', display: 'flex', flexDirection: 'column', transition: 'border-color 0.15s' }}>
                    {rBrandBg && <img loading="lazy" src={rBrandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(4px) brightness(0.3)', zIndex: 0 }} />}
                    <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at bottom, ${rBrandColor}22 0%, transparent 70%)`, zIndex: 1 }} />
                    {rival && (
                      <button onClick={e => { e.stopPropagation(); setGameSettingsData(p => ({ ...p, rivals: (p.rivals || [null,null,null]).map((r, ri) => ri === i ? null : r) })); }}
                        style={{ position: 'absolute', top: '6px', right: '6px', zIndex: 4, background: 'rgba(0,0,0,0.6)', border: '1px solid rgba(231,76,60,0.4)', color: 'rgba(231,76,60,0.7)', borderRadius: '3px', padding: '1px 6px', fontSize: '0.45rem', cursor: 'pointer', fontFamily: "'Monda',sans-serif" }}>✕</button>
                    )}
                    {rival
                      ? <>
                          <div style={{ position: 'relative', zIndex: 2, flex: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', overflow: 'hidden' }}>
                            <img loading="lazy" src={rGmRender || placeholderGm} alt={rival.gm} style={{ height: '200px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.9))', marginBottom: '-4px' }} />
                          </div>
                          <div style={{ position: 'relative', zIndex: 2, padding: '6px 8px 8px', background: 'rgba(0,0,0,0.75)', borderTop: `1px solid ${rBrandColor}44`, textAlign: 'center' }}>
                            {rBrandLogo && <img loading="lazy" src={rBrandLogo} alt={rival.brand} style={{ height: '36px', objectFit: 'contain', marginBottom: '4px', filter: 'drop-shadow(0 1px 4px rgba(0,0,0,0.9))' }} />}
                            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.42rem', color: 'rgba(255,255,255,0.5)' }}>{rival.gm}</div>
                          </div>
                        </>
                      : <div style={{ position: 'relative', zIndex: 2, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                          <div style={{ width: '28px', height: '28px', borderRadius: '50%', border: '1px dashed rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.2)', fontSize: '1rem' }}>+</div>
                          <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.42rem', color: 'rgba(255,255,255,0.2)', letterSpacing: '1px' }}>RIVAL {i + 1}</div>
                        </div>
                    }
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* ── ROSTER ── */}
        <div style={{ ...panel, padding: '18px 24px' }}>
          <div style={{ fontFamily: "'Anton',sans-serif", letterSpacing: '2px', color: '#fff', fontSize: '0.85rem', textAlign: 'center', marginBottom: '14px', textShadow: '0 0 18px rgba(180,0,0,0.4)' }}>ROSTER</div>
          <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {['default', 'custom'].map(mode => (
              <button key={mode} className="btn-wwe"
                onClick={() => { setRosterMode(mode); if (mode === 'import') setGameVersion(null); }}
                style={{ ...btnSt, minWidth: '180px', borderColor: rosterMode === mode ? 'rgba(255,255,255,0.65)' : 'rgba(255,255,255,0.25)', color: rosterMode === mode ? '#fff' : 'rgba(255,255,255,0.45)', background: rosterMode === mode ? 'rgba(255,255,255,0.07)' : 'transparent' }}>
                {mode === 'default' ? 'DEFAULT ROSTER' : 'CUSTOM ROSTER'}
              </button>
            ))}

            {/* Game version picker — visible when DEFAULT or CUSTOM ROSTER selected */}
            {(rosterMode === 'default' || rosterMode === 'custom') && (
              <div style={{ width: '100%', marginTop: '10px' }}>
                <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '1px', textAlign: 'center', marginBottom: '8px' }}>SELECT GAME</div>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                  {[
                    { id: '2k25', label: 'WWE 2K25', color: '#3a8fd4' },
                    { id: '2k26', label: 'WWE 2K26', color: '#d4af37' },
                  ].map(v => {
                    var isSelected = gameVersion === v.id;
                    return (
                      <button key={v.id} className="btn-wwe"
                        onClick={() => {
                          setGameVersion(v.id);
                          fetchOfficialWrestlers(v.id);
                        }}
                        style={{ ...btnSt, minWidth: '140px', borderColor: isSelected ? v.color : 'rgba(255,255,255,0.18)', color: isSelected ? v.color : 'rgba(255,255,255,0.35)', background: isSelected ? (v.color + '18') : 'transparent', fontFamily: "'Anton',sans-serif", letterSpacing: '2px', fontSize: '0.65rem' }}>
                        {v.label}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
            {/* WITH/WITHOUT IMPORTS — visible seulement si imports existants et default sélectionné */}
            {rosterMode === 'default' && existingImports.length > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px', justifyContent: 'center' }}>
                <div style={{ fontSize: '0.4rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '1px' }}>
                  {existingImports.length} IMPORTED WRESTLERS:
                </div>
                <div style={{ display: 'flex', gap: '6px' }}>
                  {[false, true].map(val => (
                    <button key={val} className="btn-wwe"
                      onClick={() => setWithImports(val)}
                      style={{ ...btnSt, fontSize: '0.38rem', padding: '4px 12px', borderColor: withImports === val ? 'rgba(212,175,55,0.6)' : 'rgba(255,255,255,0.15)', color: withImports === val ? '#d4af37' : 'rgba(255,255,255,0.3)', background: withImports === val ? 'rgba(212,175,55,0.06)' : 'transparent' }}>
                      {val ? 'WITH IMPORTS' : 'WITHOUT IMPORTS'}
                    </button>
                  ))}
                </div>
              </div>
            )}
            <button className="btn-wwe"
              onClick={() => { setRosterMode('import'); setShowImport(true); }}
              style={{ ...btnSt, minWidth: '180px', borderColor: rosterMode === 'import' ? 'rgba(212,175,55,0.7)' : 'rgba(212,175,55,0.3)', color: rosterMode === 'import' ? '#d4af37' : 'rgba(212,175,55,0.5)', background: rosterMode === 'import' ? 'rgba(212,175,55,0.08)' : 'transparent' }}>
              ⇪ IMPORT ROSTER
            </button>
          </div>
        </div>

        {/* Footer */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <button className="btn-wwe" style={{ ...btnSt, color: 'rgba(255,255,255,0.35)', borderColor: 'rgba(255,255,255,0.15)' }}
            onClick={() => { setStep('brand'); setSelectedGM(null); setRosterMode(null); setGameVersion(null); setSettingsConfirmed(false); }}>← BACK</button>
          {(() => {
            var hasMinRival = (gameSettingsData.rivals || []).filter(Boolean).length >= 1;
            var canConfirm = selectedGM && rosterMode && hasMinRival && (rosterMode === 'import' || gameVersion);
            return (
              <button className="btn-wwe"
                style={{ ...btnSt, borderColor: canConfirm ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.18)', color: canConfirm ? '#fff' : 'rgba(255,255,255,0.25)' }}
                onClick={() => {
                  if (!canConfirm) return;
                  if (rosterMode === 'custom') setShowCustomRosterManager(true);
                  else if (rosterMode === 'import') setShowImport(true);
                  else {
                    var base = officialWrestlers.filter(function(w) { return w.status !== 'gm'; });
                    var roster = withImports && existingImports.length > 0 ? [...base, ...existingImports] : base;
                    goToReview(roster);
                  }
                }}
                disabled={!canConfirm}>
                CONFIRM
              </button>
            );
          })()}
        </div>
      </div>

      {/* Rival picker popup */}
      {rivalPickerIdx !== null && (
        <RivalPickerPopup
          rival={(gameSettingsData.rivals || [null,null,null])[rivalPickerIdx]}
          customBrands={customBrands}
          customGMs={customGMs}
          excludeBrand={selectedBrand && selectedBrand.name}
          excludeGM={selectedGM}
          onClose={() => setRivalPickerIdx(null)}
          onSave={(data) => {
            setGameSettingsData(p => ({ ...p, rivals: (p.rivals || [null,null,null]).map((r, i) => i === rivalPickerIdx ? data : r) }));
            setRivalPickerIdx(null);
          }}
        />
      )}
    </div>
  );

  return null;
}
